import { render, staticRenderFns } from "./ManualPage.vue?vue&type=template&id=01fd37fb"
import script from "./ManualPage.vue?vue&type=script&lang=js"
export * from "./ManualPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports